export enum TOKEN_REFRESH_MS {
  BEFORE_EXPIRY = 2 * 24 * 60 * 60 * 1000,
  MAX_TIMEOUT = 2_147_483_647,
}
